document.addEventListener("DOMContentLoaded", function () {
  const parentLinks = document.querySelectorAll(".collapsible .parentlink");
  const childLinks = document.querySelectorAll(".collapsible1 .childlink");

  // Handle parent menu toggle
  parentLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      const parent = link.parentElement;
      const hasSubmenu = parent.querySelector(".content");

      if (hasSubmenu) {
        event.preventDefault(); // Prevent navigation for collapsible menus

        // Close all other open parent menus
        document.querySelectorAll(".collapsible.open").forEach((openMenu) => {
          if (openMenu !== parent) {
            openMenu.classList.remove("open");
          }
        });

        // Toggle the clicked menu
        parent.classList.toggle("open");
      }
    });
  });

  // Handle child menu toggle
  childLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      const childParent = link.parentElement;
      const hasGrandchildMenu = childParent.querySelector(".content");

      if (hasGrandchildMenu) {
        event.preventDefault(); // Prevent navigation only if submenu exists

        // Toggle the submenu visibility
        childParent.classList.toggle("open");

        // Ensure only one submenu is open at a time
        document.querySelectorAll(".collapsible1.open").forEach((openChild) => {
          if (openChild !== childParent) {
            openChild.classList.remove("open");
          }
        });
      }
    });
  });
});
